import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '@pages/home';

/** Route fur die Startseite (/). */
export const Route = createFileRoute('/')({ component: HomePage });
